module.exports = __webpack_public_path__ + "media/images/accountSection__settingsClose--dark-ceee6ee58544766080f7ca5201f465e6.png";